import React from 'react';

export function useModalState(initialOpen = false) {
  const [open, setOpen] = React.useState(initialOpen);
  const anchor = React.useRef<HTMLElement>();
  const hide = React.useCallback(() => {
    setOpen(false);
  }, []);
  const show = React.useCallback(() => {
    setOpen(true);
  }, []);
  return {
    open,
    setOpen,
    hide,
    show,
    anchor,
  };
}
